<template>
  <div class="content-quiz-body">
    <h2 class="question">{{ question.content }}</h2>
    <answers :answers="question.options" :multiselect="question.multiselect" />
  </div>
</template>
<script>
import Answers from "./answers"
export default {
  components: {
    Answers
  },
  props: {
    question: {
      type: Object,
      required: true
    }
  }
}
</script>
